/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  card: {
    marginBottom: Tokens.spacing['$sp-3'],
    border: 'none',
    boxShadow: 'none',
  },
  cardHeader: {
    paddingTop: 0,
    paddingBottom: 0
  },
  cardField: {
    marginTop: Tokens.spacing['$sp-3'],
  },
  titleMinutes: {
    fontWeight: 500,
  },
  titleNotSet: {
    fontWeight: 500,
    color: theme.palette.error.main,
  }
}));